import './ellipsis.css';
export var ellipsis = '_oqqp1n0-3-12-1';